import { css } from "styled-components"
import { COLOR } from "styles/style-constants"

export const blueGradient = css`
  background: linear-gradient(
    90deg,
    ${COLOR.brightBlue},
    ${COLOR.brightBlue},
    ${COLOR.lightShallowBlue}
  );
  color: ${COLOR.white};
`

export const grayDisabled = css`
  background: ${COLOR.lineGray};
  box-shadow: 0 0 0 0;
  cursor: not-allowed;
  color: ${COLOR.white};
`

export const greenGradient = css`
  background: linear-gradient(to right, ${COLOR.green}, ${COLOR.springGreen});
  border: 0px;
  color: ${COLOR.white};
`

export const blueGradientHovered = css`
  background: linear-gradient(
    to right,
    ${COLOR.brightBlue},
    ${COLOR.brightBlue}
  );
  border: 0px;
  color: ${COLOR.white};
`

export const transparentBtn = css`
  background-color: transparent;
  border: 0px;
  color: ${COLOR.white};
`
